export interface OrderItem {
  sku: string;
  name: string;
  orderId: number;
  quantity: number;
  currency: string;
  itemPrice: number;
  nameArabic: string;
  type: string | null;
  itemUrl: string | null;
  itemDescription: string;
  imageUrl: string | null;
  itemUnit: string | null;
  itemSize: string | null;
  itemColor: string | null;
  itemBrand: string | null;
  itemGender: string | null;
  itemCategory: string | null;
  itemDescriptionArabic: string;
}

export interface Installment {
  id: number;
  amount: number;
  dueDate: string;
  currency: string;
  paidDate?: string;
  finalAmount: number;
  dueDateDesc?: string;
  originalAmount: number;
  nbOfInstallment: number;
  status: InstallmentStatus;
  nbOfInstallmentDesc?: string;
}

export enum InstallmentStatus {
  PAID = 'PAID',
  FAILED = 'FAILED',
  MISSED = 'MISSED',
  UNPAID = 'UNPAID',
  PENDING = 'PENDING',
}

export enum PaymentPlanId {
  ONE_MONTH = 'ONE_MONTH',
  TWO_MONTHS = 'TWO_MONTHS',
  THREE_MONTHS = 'THREE_MONTHS',
  ONE_MONTH_PAY_NOW = 'ONE_MONTH_PAY_NOW',
}

export enum PaymentPlanDisabledReason {
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
}

export enum OrderStatus {
  SETTLED = 'SETTLED',
  CANCELED = 'CANCELED',
  REFUNDED = 'REFUNDED',
  REJECTED = 'REJECTED',
  CONFIRMED = 'CONFIRMED',
  INITIATED = 'INITIATED',
  UNSETTLED = 'UNSETTLED',
  FULL_REFUND = 'FULL_REFUND',
  INCOMPLETED = 'INCOMPLETED',
  PARTIAL_REFUND = 'PARTIAL_REFUND',
}

export interface OrderDetails {
  id: number;
  amount: number;
  currency: string;
  storeName: string;
  orderDate: string;
  orderToken: string;
  merchantId: number;
  status: OrderStatus;
  customerName: string;
  merchantName: string;
  userId: number | null;
  merchantBrand: string;
  discountAmount: number;
  orderItems: OrderItem[];
  merchantLogoUrl: string;
  merchantOrderId: string;
  shippingCharges: number;
  dueAmount: number | null;
  paymentId: string | null;
  OrderDescription?: string;
  redirectUrl: string | null;
  merchantNameArabic: string;
  paymentDate: string | null;
  paymentType: string | null;
  referenceId: string | null;
  installments: Installment[];
  paymentMethod: string | null;
  customerMobileNumber: string;
  paymentPlanName: string | null;
  paymentPlanId: PaymentPlanId | null;
  downPaymentPercentage: number | null;
}

export interface PaymentDetails extends OrderDetails {
  expiresAt: string;
  overdueAmount: number;
  paymentLinkStatus: PaymentStatus;
  userPreferenceLanguage: 'EN' | 'AR';
}

export enum PaymentStatus {
  PAID = 'PAID',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED',
  INITIATED = 'INITIATED',
}
